module.exports = __webpack_public_path__ + "img/W_green.de3f59f1.svg";